// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "select[name=\"rcrs-country\"]{\n  outline: none;\n  border: none;\n  background-color: transparent;\n  font-size: 17px;\n  margin-top: 20px;\n  margin-left: -5px;\n}", ""]);
// Exports
module.exports = exports;
